/* Impression SCDM — la resolution du fichier suit la commande.

   Le probleme, en atelier : un client televerse une photo prise au telephone,
   la fait imprimer en 6 po, et le resultat est flou. Le configurateur le lui
   disait deja sous l apercu (« Votre image donne 96 ppp a cette grandeur »),
   mais ce chiffre restait a l ecran : il n arrivait jamais sur la commande.
   Impossible, en ouvrant une commande dans Shopify, de savoir si le fichier
   etait bon ou s il allait demander une retouche.

   Ce fichier fait deux choses :

   1. IL ECRIT LA RESOLUTION SUR LA COMMANDE. Chaque design de
      window.SCDM.commande porte un objet « props », et scdm.js envoie chaque
      cle de props au panier comme propriete de ligne. On y ajoute donc
      « Resolution » au moment ou le design est ajoute. Le chiffre apparait sur
      la commande, a cote du format et du materiau.

   2. IL FAIT ACCEPTER L AVERTISSEMENT AU CLIENT. Sous le seuil, un encadre
      apparait a cote du bouton d ajout et il faut cocher une case pour
      continuer. Ce n est pas un obstacle commercial : le client passe quand
      meme sa commande. C est une trace — la commande porte alors
      « Client averti de la basse resolution et a accepte », ce qui permet de
      proposer une retouche sans que ce soit une surprise.

   D OU VIENT LE CHIFFRE : on ne le recalcule pas. scdm.js le calcule deja et
   l affiche dans #scdmCoteNote ; on lit ce texte. Deux avantages : le seuil
   n existe qu a un seul endroit (dans scdm.js), et ce qui part sur la commande
   est exactement ce que le client a vu a l ecran. Si le seuil change dans
   scdm.js, ce fichier suit tout seul — il repere le cas « bas » a la classe
   « avert » que scdm.js pose sur la note.

   LE FICHIER PRIME SUR LA NOTE. Corrige le 5 septembre 2026. Un modele de la
   bibliotheque dont le fichier d impression est un PDF vectoriel s affiche a
   l ecran par sa VIGNETTE PNG : scdm.js mesure alors les pixels de la
   vignette, trouve 45 ppp a 600 mm et crie au flou — sur un fichier qui n a
   aucune resolution. Tous les panneaux routiers etaient dans ce cas. On
   regarde donc l EXTENSION DU FICHIER d abord, et la note ensuite. Quand le
   fichier est vectoriel, on reecrit aussi la note que le client a sous les
   yeux : lui laisser un avertissement orange sous un dessin parfaitement net,
   c est lui faire douter d une commande qui va tres bien sortir.

   LES MODELES DE L ATELIER NE SONT JAMAIS AVERTIS. Ajoute le 6 septembre 2026,
   a la demande de l atelier. L avertissement de resolution s adresse au client
   au sujet du fichier qu il vient de televerser. Les modeles de la
   bibliotheque, eux, sont vectorises et retouches en atelier avant d etre mis
   en ligne : leur qualite est acquise, et l apercu a l ecran n est parfois
   qu une vignette. On les reconnait au nom que scdm-modeles.js leur donne
   toujours, « modele-scdm-<id>.<ext> ». La sortie se fait dans mesure(), la
   seule fonction qui decide si la resolution est basse : l encadre orange et
   sa case a cocher disparaissent donc ensemble, et le bouton d ajout reste
   libre. Un fichier televerse par le client garde tout le controle habituel.

   Charge depuis snippets/scdm-minimum.liquid, apres scdm-vierge.js (qui bloque
   deja le bouton tant qu il manque un choix) et avant scdm-remarque.js. */

(function () {
  'use strict';

  function texteResolution(cle, repli) {
    var racine = document.getElementById('scdmConfig');
    return (racine && racine.getAttribute('data-config-resolution_' + cle)) || repli;
  }

  function htmlResolution(cle, repli) {
    return texteResolution(cle, repli).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }


  function texteContour(cle, repli, params) {
    var pont = document.getElementById('scdmContourI18n');
    var texte = (pont && pont.getAttribute('data-' + cle)) || repli;
    Object.keys(params || {}).forEach(function (nom) {
      texte = texte.split('{' + nom + '}').join(String(params[nom]));
    });
    return texte;
  }


  var CLE = 'Résolution';
  var CLE_AVIS = 'Contrôle qualité';

  var VECTORIEL = /\.(pdf|ai|eps|svg)$/i;

  var encadre = null;
  var caseAcc = null;
  var bas = false;          // l avertissement de scdm.js est affiche
  var dernier = '';         // ce qu on ecrira sur la commande

  /* ---------------------------------------------------------------- style */

  function style() {
    if (document.getElementById('scdmResoStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmResoStyle';
    s.textContent = [
      '.scdm .reso-avert{margin:12px 0 0;padding:12px 14px;border-radius:10px;',
      'border:1px solid var(--or,#FF7A18);background:rgba(255,122,24,.08);',
      'font-size:12.5px;line-height:1.5}',
      '.scdm .reso-avert strong{display:block;margin-bottom:4px;font-size:13px}',
      '.scdm .reso-avert p{margin:0 0 8px}',
      '.scdm .reso-acc{display:flex;gap:8px;align-items:flex-start;cursor:pointer;margin:0}',
      '.scdm .reso-acc input{margin:2px 0 0;flex:0 0 auto}',
      '.scdm .reso-rappel{margin:8px 0 0;font-size:12px;color:var(--or,#FF7A18)}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------- lire la note */

  /* La note de scdm.js, telle que le client la voit. On en tire le nombre de
     ppp et, a la classe « avert », le fait qu il soit sous le seuil. */
  function lireNote() {
    var note = document.getElementById('scdmCoteNote');
    if (!note || note.hidden) return null;
    var t = (note.textContent || '').trim();
    if (!t) return null;
    var m = t.match(/(\d+)\s*(?:ppp|dpi)\b/i);
    if (!m) return null;
    return { ppp: parseInt(m[1], 10), bas: /\bavert\b/.test(note.className) };
  }

  function nomFichier() {
    var e = window.SCDM && window.SCDM.etat;
    return (e && e.fichier && e.fichier.name) || '';
  }

  /* Ce qui partira sur la commande, dans les mots de l atelier. */
  function vectoriel() {
    var nom = nomFichier();
    return !!(nom && VECTORIEL.test(nom));
  }

  /* Un fichier de la bibliotheque de l atelier, pas du client. scdm-modeles.js
     depose toujours « modele-scdm-<id>.<ext> » — c est au meme nom que
     scdm-phospho.js reconnait ses douze pancartes. L atelier vectorise et
     retouche lui-meme ses propres modeles avant de les mettre en ligne :
     l avertissement de resolution ne le concerne pas, il n existe que pour
     prevenir le client sur SON fichier a lui. */
  function fichierDeLAtelier() {
    return /^modele-scdm-.+\.[A-Za-z0-9]+$/.test(nomFichier());
  }

  function mesure() {
    /* D ABORD le fichier : un vectoriel n a pas de resolution, quoi que la
       note affiche. */
    if (vectoriel()) {
      return { bas: false, texte: 'Fichier vectoriel — pleine qualité à toute grandeur' };
    }
    /* ENSUITE la provenance. Un modele de la bibliotheque affiche parfois sa
       vignette matricielle : scdm.js y mesure alors des pixels et croit au
       flou. Ce n est pas ce fichier-la qui sera imprime, et il ne vient pas
       du client — on sort ici, avant tout calcul. « bas » reste faux, donc
       l encadre ET sa case a cocher restent absents ensemble et le bouton
       d ajout n est jamais bloque par une case qui n existe plus. */
    if (fichierDeLAtelier()) {
      return { bas: false, texte: 'Modèle de la bibliothèque — fichier d’impression fourni par l’atelier' };
    }
    var n = lireNote();
    if (n) {
      return {
        bas: n.bas,
        texte: n.ppp + ' ppp à cette grandeur' + (n.bas ? ' — SOUS LE MINIMUM' : ' — conforme')
      };
    }
    var nom = nomFichier();
    var e = window.SCDM && window.SCDM.etat;
    if (!nom && e && e.img) {
      return { bas: false, texte: 'Modèle de la bibliothèque — fichier d’impression fourni par l’atelier' };
    }
    return null;
  }

  /* --------------------------------------------------------- l encadre */

  function poser() {
    /* ON VERIFIE QU IL EST ENCORE DANS LA PAGE. Garder la reference sans
       verifier, c est parler dans le vide le jour ou un redessin l emporte :
       le clic reste bloque et plus personne ne dit pourquoi. */
    if (encadre && document.body.contains(encadre)) return true;
    if (encadre) { encadre = null; caseAcc = null; bas = false; }
    var b = document.getElementById('scdmAjouter');
    if (!b || !b.parentNode) return false;

    encadre = document.createElement('div');
    encadre.className = 'reso-avert';
    encadre.id = 'scdmResoAvert';
    encadre.hidden = true;
    encadre.setAttribute('role', 'status');
    encadre.innerHTML =
      '<strong>' + htmlResolution('heading', "Votre image est sous la qualité recommandée") + '</strong>' +
      '<p>' + htmlResolution('warning', "À cette grandeur, l’impression risque d’être floue ou pixelisée. Le mieux est d’envoyer un fichier plus gros, ou un PDF ou un .AI si vous en avez un. Vous pouvez tout de même commander : nous vérifions chaque fichier avant d’imprimer. Si une retouche est nécessaire, nous vous écrivons avec le prix — rien n’est ajouté à votre commande sans votre accord.") + '</p>' +
      '<label class="reso-acc" for="scdmResoOk">' +
      '<input type="checkbox" id="scdmResoOk">' +
      '<span>' + htmlResolution('accept', "J’ai lu l’avertissement et je veux continuer avec ce fichier.") + '</span>' +
      '</label>';

    /* Avant le bouton : le client lit l avertissement en descendant vers lui,
       pas apres l avoir clique. */
    b.parentNode.insertBefore(encadre, b);
    caseAcc = document.getElementById('scdmResoOk');
    caseAcc.addEventListener('change', function () {
      var r = document.getElementById('scdmResoRappel');
      if (r && caseAcc.checked) r.parentNode.removeChild(r);
    });
    return true;
  }

  /* La note de scdm.js, telle que le client la lit. Sur un fichier vectoriel
     elle est fausse : on la remplace. On verifie avant d ecrire, sinon
     l observateur qui nous appelle se rappellerait lui-meme sans fin. */
  var NOTE_VECT = 'Fichier vectoriel — net à n’importe quelle grandeur.';
  var NOTE_ATELIER = 'Modèle de la bibliothèque — fichier d’impression préparé par l’atelier.';

  /* Le texte qui doit remplacer celui de scdm.js, ou null s il faut le laisser
     tel quel. Le vectoriel passe en premier : un modele de la bibliotheque
     livre en PDF garde donc exactement le message qu il affichait deja. */
  function noteAReecrire() {
    if (vectoriel()) return texteContour('vector', NOTE_VECT);
    if (fichierDeLAtelier()) return texteContour('library', NOTE_ATELIER);
    return null;
  }

  function neutraliserNote() {
    var note = document.getElementById('scdmCoteNote');
    if (!note) return;
    var texte = noteAReecrire();
    if (!texte) return;
    var deja = note.textContent === texte && !/\bavert\b/.test(note.className);
    if (deja) return;
    note.className = String(note.className).replace(/\bavert\b/g, '').trim();
    note.textContent = texte;
    note.hidden = false;
  }

  function peindre() {
    neutraliserNote();
    if (!encadre && !poser()) return;
    var m = mesure();
    dernier = m ? m.texte : '';
    var neuf = !!(m && m.bas);

    /* On repasse aussi quand l affichage a derive de l etat : « bas » vrai
       et encadre masque, c est le bouton muet. */
    if (neuf === bas && encadre.hidden === !bas) return;
    bas = neuf;
    encadre.hidden = !bas;
    if (!bas) {
      if (caseAcc) caseAcc.checked = false;
      var r = document.getElementById('scdmResoRappel');
      if (r) r.parentNode.removeChild(r);
    }
  }

  /* --------------------------------------------------- au moment d ajouter */

  function accrocher() {
    var b = document.getElementById('scdmAjouter');
    if (!b) return;

    var avant = 0;

    /* CAPTURE, donc avant scdm.js. Si l image est basse et que la case n est
       pas cochee, le clic s arrete ici. scdm-vierge.js, charge avant nous, a
       deja pu couper la chaine s il manquait un choix : c est voulu, on ne
       fatigue pas le client avec deux reproches a la fois. */
    b.addEventListener('click', function (e) {
      peindre();
      if (bas && caseAcc && !caseAcc.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!document.getElementById('scdmResoRappel')) {
          var p = document.createElement('p');
          p.id = 'scdmResoRappel';
          p.className = 'reso-rappel';
          p.setAttribute('role', 'alert');
          p.textContent = texteResolution('reminder', "Cochez la case ci-dessus pour continuer avec ce fichier.");
          encadre.appendChild(p);
        }
        if (encadre.scrollIntoView) encadre.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      avant = ((window.SCDM && window.SCDM.commande) || []).length;
    }, true);

    /* En bulle, donc apres scdm.js : le design vient d etre cree. Si le nombre
       n a pas bouge, l ajout a echoue et il n y a rien a annoter. */
    b.addEventListener('click', function () {
      var liste = (window.SCDM && window.SCDM.commande) || [];
      if (liste.length <= avant) return;

      var d = liste[liste.length - 1];
      d.props = d.props || {};
      if (dernier) d.props[CLE] = dernier;
      if (bas) d.props[CLE_AVIS] = 'Basse résolution — client averti et a accepté';

      /* Le design suivant repart sans avertissement : le fichier a ete vide. */
      if (caseAcc) caseAcc.checked = false;
      bas = false;
      if (encadre) encadre.hidden = true;
      var r = document.getElementById('scdmResoRappel');
      if (r) r.parentNode.removeChild(r);
    }, false);
  }

  /* ------------------------------------------------------------ demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    if (!poser()) return;
    accrocher();

    /* scdm.js reecrit la note a chaque changement de format, de fichier ou
       d unite. On la relit apres chaque reecriture. */
    var note = document.getElementById('scdmCoteNote');
    if (note) {
      var o = new MutationObserver(peindre);
      o.observe(note, { childList: true, characterData: true, subtree: true, attributes: true,
                        attributeFilter: ['class', 'hidden'] });
    }
    /* Filet : le fichier peut changer sans que la note bouge (passage d une
       image a un PDF, ou retrait du fichier). */
    setInterval(peindre, 600);
    peindre();
  }

  function quandPret(n) {
    if (document.getElementById('scdmAjouter') && window.SCDM && window.SCDM.commande) return demarrer();
    if ((n || 0) > 60) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
